/**
 * Normalizes a browser locale string to the two-letter language code the API accepts.
 * e.g. "en-US" → "en", "fr-FR" → "fr"
 */
export function normalizeLocale(lang: string): string {
  return lang.split('-')[0];
}
